import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { SupersetService } from '../../services/superset.service';
import { Chart } from 'chart.js/auto';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {
  @Input() chartId!: number;
  @ViewChild('canvas') canvasRef!: ElementRef;

  constructor(private superset: SupersetService) {}

  async ngOnInit() {
    await this.superset.login('admin', 'admin'); // 👈 use your Superset credentials
    const response: any = await this.superset.getChartData(this.chartId);

    const chartData = response.result[0].data;

    const ctx = this.canvasRef.nativeElement.getContext('2d');
    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: chartData.map((d: any) => d.category || d.name),
        datasets: [
          {
            label: 'Value',
            data: chartData.map((d: any) => d.value || d.metric),
            backgroundColor: 'rgba(75, 192, 192, 0.6)'
          }
        ]
      },
      options: {
        responsive: true,
        plugins: { legend: { display: true } }
      }
    });
  }
}
